// NOTE: I would consider things in here to be deprecated. Opt for using the
// /user directory, which uses the schema loader instead of manually constructing
// class instances.

export type DirectReportAPIData = {
	display_name: string;
	email: string;
	id: string;
	last_recognition_at: number;
	profile_pic_url: string;
	recognition_count: number;
	username: string;
	deleted_at: string | null;
};

export type DirectReportAttributes = {
	displayName: string;
	email: string;
	id: string;
	lastRecognitionAt: Date;
	profilePic: string;
	recognitionCount: number;
	username: string;
	deletedAt: string | null;
};

/**
 * @deprecated
 */
export class DirectReportEntity implements DirectReportAttributes {
	readonly displayName: string;
	readonly email: string;
	readonly id: string;
	readonly lastRecognitionAt: Date;
	readonly profilePic: string;
	readonly recognitionCount: number;
	readonly username: string;
	readonly deletedAt: string | null;

	constructor(data: DirectReportAttributes) {
		this.displayName = data.displayName;
		this.email = data.email;
		this.id = data.id;
		this.lastRecognitionAt = data.lastRecognitionAt;
		this.profilePic = data.profilePic;
		this.recognitionCount = data.recognitionCount;
		this.username = data.username;
		this.deletedAt = data.deletedAt;
	}
}

export type UserIndexAPIData = {
	id: string;
	custom_properties: {
		[k: string]: string;
	};
	display_name: string;
	email: string;
	first_name: string;
	display_first_name: string;
	last_name: string;
	locale: string;
	profile_pic: string;
	time_zone: string | null;
	user_mode: string;
	manager_id: string | null;
	username: string;
	deleted_at: string | null;
	status: string;
	created_at: string;
	updated_at: string;
};

export type UserIndexAttributes = {
	id: string;
	customProperties: {
		[k: string]: string;
	};
	displayName: string;
	email: string;
	firstName: string;
	displayFirstName: string;
	lastName: string;
	locale: string;
	profilePic: string;
	timeZone: string | null;
	userMode: string;
	managerId: string | null;
	username: string;
	deletedAt: string | null;
	status: string;
	createdAt: Date;
	updatedAt: Date;
};

/**
 * @deprecated
 */
export class UserIndexEntity implements UserIndexAttributes {
	readonly id: string;
	readonly customProperties: {
		[k: string]: string;
	};
	readonly displayName: string;
	readonly email: string;
	readonly firstName: string;
	readonly displayFirstName: string;
	readonly lastName: string;
	readonly locale: string;
	readonly managerId: string | null;
	readonly profilePic: string;
	readonly timeZone: string | null;
	readonly userMode: string;
	readonly username: string;
	readonly deletedAt: string | null;
	readonly status: string;
	readonly createdAt: Date;
	readonly updatedAt: Date;

	constructor(data: UserIndexAttributes) {
		this.id = data.id;
		this.customProperties = data.customProperties;
		this.displayName = data.displayName;
		this.email = data.email;
		this.firstName = data.firstName;
		this.displayFirstName = data.displayFirstName;
		this.lastName = data.lastName;
		this.locale = data.locale;
		this.profilePic = data.profilePic;
		this.timeZone = data.timeZone;
		this.managerId = data.managerId;
		this.userMode = data.userMode;
		this.username = data.username;
		this.deletedAt = data.deletedAt;
		this.status = data.status;
		this.createdAt = new Date(data.createdAt);
		this.updatedAt = new Date(data.updatedAt);
	}
}

export type UserDetailAPIData = UserIndexAPIData;

export type UserDetailAttributes = UserIndexAttributes;

/**
 * @deprecated
 */
export class UserDetailEntity extends UserIndexEntity {}
